<template>
  <div class="summary-container">
    <!-- Quantidade de sessões -->
    <div class="summary-card">
      <p class="summary-title">
        {{ $t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.SUMMARY.TOTAL_SESSIONS') }}
      </p>
      <p class="summary-value">{{ totalSessions.toLocaleString() }}</p>
    </div>

    <!-- Média de interações -->
    <div class="summary-card">
      <p class="summary-title">
        {{
          $t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.SUMMARY.AVG_INTERACTIONS')
        }}
      </p>
      <p class="summary-value">
        {{ averageInteractions.toFixed(2) }}
      </p>
    </div>

    <!-- Duração média -->
    <div class="summary-card">
      <p class="summary-title">
        {{ $t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.SUMMARY.AVG_DURATION') }}
      </p>
      <p class="summary-value">
        {{ formattedAverageDuration }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VirtualAssistantEventsSummary',
  props: {
    events: {
      type: Array,
      required: true,
    },
  },
  computed: {
    totalSessions() {
      return this.events.length;
    },
    averageInteractions() {
      if (!this.events.length) return 0;

      const total = this.events.reduce(
        (sum, e) => sum + (e.interactions_count || 0),
        0
      );

      return total / this.events.length;
    },
    averageDuration() {
      if (!this.events.length) return 0;

      const total = this.events.reduce(
        (sum, e) => sum + (e.duration_interaction || 0),
        0
      );

      return total / this.events.length;
    },
    formattedAverageDuration() {
      const totalSeconds = Math.floor(this.averageDuration);

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      return [hours, minutes, seconds]
        .map(v => String(v).padStart(2, '0'))
        .join(':');
    },
  },
};
</script>

<style scoped>
.summary-container {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.summary-card {
  background-color: #e0e0e0;
  border-radius: 10px;
  padding: 20px 24px;
  min-width: 180px;
  flex: 0 0 auto;
}

.summary-title {
  font-size: 14px;
  color: #555;
  margin-bottom: 8px;
}

.summary-value {
  font-size: 24px;
  font-weight: bold;
  color: #222;
}
</style>
